export async function fetchChartData(chartType) {
    const response = await fetch(`/stats/data/${chartType}`);
    if (!response.ok) {
        throw new Error(`Error fetching data for chart type ${chartType}`);
    }
    return response.json();
}
